var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-grid", attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "console" },
      [
        _c("h2", [_vm._v("指令修仙")]),
        _vm._v(" "),
        _c(
          "div",
          { ref: "output", staticClass: "output" },
          _vm._l(_vm.outputLines, function (line, idx) {
            return _c(
              "div",
              { key: idx, staticClass: "out-line" },
              [
                _vm._l(
                  _vm.tokenizeCommandText(line.text),
                  function (part, pidx) {
                    return [
                      part.isCmd
                        ? _c(
                            "button",
                            {
                              key: pidx,
                              staticClass: "cmd-link",
                              on: {
                                click: function ($event) {
                                  return _vm.runSuggested(
                                    part.actualCmd || part.text
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(part.text))]
                          )
                        : _c(
                            "span",
                            {
                              key: pidx + "-t",
                              class: ["out-text", line.type || "response"],
                            },
                            [_vm._v(_vm._s(part.text))]
                          ),
                    ]
                  }
                ),
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-row" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.commandInput,
                expression: "commandInput",
              },
            ],
            ref: "input",
            attrs: {
              placeholder: "输入命令（直接发送查看帮助）",
              disabled: _vm.needsName,
            },
            domProps: { value: _vm.commandInput },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.sendCommand.apply(null, arguments)
              },
              keydown: _vm.onInputKey,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.commandInput = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("button", { on: { click: _vm.sendCommand } }, [_vm._v("发送")]),
          _vm._v(" "),
          _c("button", { on: { click: _vm.clearOutput } }, [_vm._v("清除")]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "admin-btn", on: { click: _vm.showAdminPanel } },
            [_vm._v("GM")]
          ),
          _vm._v(" "),
          _vm.showSuggestions
            ? _c(
                "div",
                { staticClass: "suggestions" },
                _vm._l(_vm.suggestions, function (item, idx) {
                  return _c(
                    "div",
                    {
                      key: idx,
                      staticClass: "item",
                      on: {
                        click: function ($event) {
                          return _vm.acceptSuggestion(item)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(item) + "\n        ")]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("NameModal", {
          attrs: { "show-name-modal": _vm.needsName },
          on: {
            message: _vm.handleMessage,
            "name-submitted": _vm.handleNameSubmitted,
          },
        }),
        _vm._v(" "),
        _vm.showItemInfoModal
          ? _c(
              "div",
              {
                staticClass: "item-info-modal",
                on: { click: _vm.closeItemInfo },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "item-info-card",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("h3", [_vm._v("物品信息")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.itemInfoText))]),
                    _vm._v(" "),
                    _c("button", { on: { click: _vm.closeItemInfo } }, [
                      _vm._v("关闭"),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("SectModal", {
          attrs: { "game-state": _vm.gameState },
          on: { "sect-result": _vm.handleSectResult },
        }),
        _vm._v(" "),
        _vm.gameState.inExplorationModal
          ? _c("ExplorationModal", {
              ref: "explorationModal",
              attrs: { "game-state": _vm.gameState },
              on: {
                "exploration-choice": _vm.handleExplorationChoice,
                "continue-exploration": _vm.handleContinueExploration,
                "end-exploration": _vm.handleEndExploration,
                "check-random-event": _vm.handleCheckRandomEvent,
                "start-exploration": _vm.handleStartExploration,
                "close-modal": _vm.handleCloseModal,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("BattleModal", {
          attrs: {
            "show-battle-modal": _vm.gameState.inBattleModal,
            "battle-state": _vm.gameState.battleState,
            "player-name": _vm.gameState.name,
            "player-skills": _vm.getPlayerSkills(),
          },
          on: {
            "use-skill": _vm.handleBattleSkill,
            "attempt-flee": _vm.handleBattleFlee,
            "close-modal": _vm.handleCloseBattleModal,
          },
        }),
        _vm._v(" "),
        _vm.gameState.inTravelModal
          ? _c("TravelModal", {
              attrs: { "game-state": _vm.gameState },
              on: {
                "travel-result": _vm.handleTravelResult,
                "close-modal": _vm.handleCloseTravelModal,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("StateModal", {
          attrs: {
            "game-state": _vm.gameState,
            "state-manager": _vm.gameController
              ? _vm.gameController.stateManager
              : null,
          },
        }),
        _vm._v(" "),
        _vm.gameState.inBagModal
          ? _c("BagModal", {
              attrs: { "game-state": _vm.gameState },
              on: {
                "show-item-info": _vm.showItemInfo,
                "use-item": _vm.handleBagItemUse,
                "close-modal": _vm.handleCloseBagModal,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.gameState.inTreasureHall
          ? _c("TreasureHallModal", {
              attrs: { "game-state": _vm.gameState },
              on: {
                "purchase-result": _vm.handlePurchaseResult,
                "save-state": _vm.saveGameState,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("AdminPanel", {
          attrs: { "show-admin-modal": _vm.showAdminModal },
          on: {
            "close-modal": function ($event) {
              _vm.showAdminModal = false
            },
          },
        }),
        _vm._v(" "),
        _vm.toastMessage
          ? _c(
              "div",
              { staticClass: "toast-notification", class: _vm.toastType },
              [
                _c("div", { staticClass: "toast-content" }, [
                  _c("span", { staticClass: "toast-icon" }, [
                    _vm._v(_vm._s(_vm.toastIcon)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "toast-text" }, [
                    _vm._v(_vm._s(_vm.toastMessage)),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "game-area" },
      [
        _c("SceneInfoPanel", {
          attrs: { "game-state": _vm.gameState },
          on: {
            "execute-command": _vm.handleExecuteCommand,
            "show-message": _vm.handleShowMessage,
          },
        }),
        _vm._v(" "),
        _c("ForbiddenMap", {
          attrs: {
            "game-state": _vm.gameState,
            "scanned-cells": _vm.scannedCells,
          },
          on: { command: _vm.sendDirectCommand },
        }),
        _vm._v(" "),
        _c("PillRefining", {
          attrs: { "game-state": _vm.gameState },
          on: { "refine-result": _vm.handleRefineResult },
        }),
        _vm._v(" "),
        _c("TreasureRefining", {
          attrs: { "game-state": _vm.gameState },
          on: { "refine-result": _vm.handleRefineResult },
        }),
        _vm._v(" "),
        !_vm.gameState.inForbiddenMap &&
        !_vm.gameState.inRefiningPill &&
        !_vm.gameState.inRefiningTreasure
          ? _c("div", { attrs: { id: "game-container" } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }